import {POAbstractOrgUnitListDecorator} from '@list-decorators/POOrgUnitListDecorator/POAbstractOrgUnitListDecorator';

export class POOrgUnitListDecorator extends POAbstractOrgUnitListDecorator {
  docKey = 'divisions';
}
